import React from 'react';
import { connect } from 'react-redux';
import { Col, Jumbotron, Row, Button } from 'react-bootstrap';
import { postLoginData } from '../../actions/login';
import Scroll from 'react-scroll'; // Imports all Mixins
import { withRouter } from 'react-router';
import LoginForm from './form';
import { LinkContainer } from 'react-router-bootstrap';
import checkLoginErrorMsg from '../../utils/checkLoginErrorMsg.js';
import './styles.css';

class Login extends React.Component<{}> {
  componentDidMount() {
    const scroll = Scroll.animateScroll;
    scroll.scrollToTop({ duration: 0 });
  }
  componentWillUpdate(nextProps) {
    if (nextProps.loginSuccess && !nextProps.basket.data.continueText.show) {
      this.props.history.push('/confirm');
    }
  }

  handleSubmit = ({ username, password }) => {
    const id = this.props.basket.data.id;
    this.props.postLoginData(id, {
      username,
      password
    });
  };
  
  render() {
    window.history.replaceState(
      null,
      "Airport Transfers to Ski Resorts | Ski-Lifts",
      "/login"
    );
    const { loginData, loginFailed } = this.props;
    const displayGuest = localStorage.getItem("guest") === "true" ? 'block' : 'none';
    loginData.message = checkLoginErrorMsg(loginData.message);

    let username = '';
    if (this.props.user.username) {
      username = this.props.user.username;
    }

    const initialValues = {
      username: username
    };

    return (
     
      <Jumbotron className="login login-bg">
        <Row>
          <Col
            xs={12} 
            md={6}
            className="text-center guest-form"
            style={{display: displayGuest }}
          >
            <h2 className="text-center">New to Ski Lifts?</h2>
            <h3 className="text-center">Please continue as a Guest</h3>
            <h5 className="text-center">Don’t forget to create a Ski-Lifts account when you've finished booking to start earning loyalty points</h5>
            <LinkContainer to="/confirm" style={{ marginTop: '70px', width: '200px' }}>
              <Button bsSize="large" bsStyle="success">
                <span>Continue</span>
              </Button>
            </LinkContainer>
          </Col>
          <Col xs={12} md={6} className="text-left" style={{ background: 'white'}}>
            <div className="container">    
                      <h2>Returning Customer{this.props.user.allowGuest && "?"}</h2><h3>Login to use your loyalty points.</h3>
            </div>
            <LoginForm initialValues={!this.props.user.allowGuest && initialValues} onSubmit={r => this.handleSubmit(r)} />
            {loginFailed ? `Login Failed: ${loginData.message}` : null}
          </Col>
        </Row>
      </Jumbotron>
    );
    
  }
  
}

export default withRouter(
  connect(
    state => ({
      loginData: state.login.data,
      loginFailed: state.login.hasFailed,
      loginSuccess: state.login.loginSuccess,
      user: state.user,
      basket: state.basket
    }),
    { postLoginData }
  )(Login)
);



// WEBPACK FOOTER //
// ./src/containers/LoginPage/index.js